import React, { useEffect, useMemo, useState } from "react";
import { Modal } from "antd";
import { Line } from "react-chartjs-2";
import dayjs from "dayjs";
import { COLORS, getResponsiveFontSize, UI_DATE_FORMAT } from "../../../consts";
import { LoadingIcon } from "../../../components";
import {getResponsiveLoadingIconSize} from "./utils";

const Graph = ({
  visible,
  onClose,
  graphDateHeaders,
  chartLines,
  viewType,
  graphLoading,
}) => {
  const [fontSize, setFontSize] = useState(getResponsiveFontSize());
  const [loadingIconSize, setLoadingIconSize] = useState(getResponsiveLoadingIconSize());

  useEffect(() => {
    const handleResize = () => {
      setFontSize(getResponsiveFontSize());
      setLoadingIconSize(getResponsiveLoadingIconSize());
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const chartData = useMemo(() => {
    if (!graphDateHeaders?.length || !chartLines?.length) {
      return { labels: [], datasets: [] };
    }

    const labels = graphDateHeaders.map((dh) =>
      dayjs(dh).format(UI_DATE_FORMAT),
    );

    const datasets = chartLines.map((lineObj, i) => {
      const dataArray = labels.map((lbl) => {
        const found = lineObj.data.find((d) => d.x === lbl);
        if (found && found.y !== 0) {
          return found.y;
        }
        return null;
      });

      const color = COLORS.graphColors[i % COLORS.graphColors.length];
      return {
        label: lineObj.name,
        data: dataArray,
        borderColor: color,
        backgroundColor: color,
        // fill: true,
        tension: 0.3,
        pointRadius: 10,
        pointHoverRadius: 15,
        pointStyle: "circle",
        spanGaps: true,
      };
    });

    return {
      labels,
      datasets,
    };
  }, [graphDateHeaders, chartLines]);

  const options = {
    responsive: true,
    plugins: {
      legend: { position: "top" },
      title: {
        display: true,
        text: `${viewType} Graph`,
        font: {
          family: "'museoSansBold', sans-serif",
          size: fontSize
        }
      },
    },
    scales: {
      y: {
        beginAtZero: false,
        title: {
          display: true,
          text: "Yield (KG)",
          font: {
            family: "'museoSansBold', sans-serif",
            size: fontSize,
          },
        },
      },
      x: {
        title: {
          display: true,
          text: "Dates",
          font: {
            family: "'museoSansBold', sans-serif",
            size: fontSize,
          },
        },
      },
    },
  };

  return (
    <Modal
      title="Data Graph"
      open={visible}
      onCancel={onClose}
      footer={null}
      maskClosable={false}
      className="
        h-[80vh]
        md:h-auto
        !w-[75vw]
        md:!w-[95vw]
        xl:!w-[85vw]
        !max-w-none
      "
    >
      {graphLoading ? (
        <div className="flex justify-center items-center h-[50vh]">
          <LoadingIcon height={loadingIconSize} />
        </div>
      ) : (
        <div className="sm:overflow-x-auto">
          <div className="sm:min-w-[600px] md:!w-[90vw] xl:!w-[80vw] !w-[70vw]">
            <Line data={chartData} options={options} />
          </div>
        </div>
      )}
    </Modal>
  );
};

export default Graph;
